/**
 * Do not edit this file it is auto-generated by io-utils / gen-api-models.
 * See https://github.com/pagopa/io-utils
 */
/* eslint-disable  */

import * as t from "io-ts";

// required attributes
const AmountR = t.interface({});

// optional attributes
const AmountO = t.partial({
  amount: t.Integer,

  currency: t.string,

  currencyNumber: t.string,

  decimalDigits: t.Integer
});

export const Amount = t.intersection([AmountR, AmountO], "Amount");

export type Amount = t.TypeOf<typeof Amount>;
